import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Navigation,
} from "swiper";
SwiperCore.use([Navigation, Autoplay]);

function ServiceArea(props) {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const serviceSlider= {
    loop: true,
    speed: 1000,
    autoplay:{
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 3,
    spaceBetween: 30,

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        }
    }
  }
  return (
    <>
      <section className={`${"services-area sec-mar"} ${props.layoutClass}`}>
        <div className="container">
          <div
            className="title-wrap wow animate fadeInUp"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className={`${"sec-title"} ${props.white}`}>
              <span>Nuestras Soluciones</span>
              {/* H2 MEJORADO: Más específico pero mantiene esencia */}
              <h2>Servicios de Desarrollo de Software</h2>
              <p>
                En Gekkonect transformamos tus ideas en soluciones tecnológicas personalizadas, diseñadas para 
                impulsar tu negocio. Nuestro equipo de expertos combina innovación, calidad y eficiencia para 
                desarrollar <strong>software a medida</strong>, que se adapta perfectamente a tus necesidades. 
                {/* Añadí estas frases naturales con keywords */}
                Somos especialistas en <strong>desarrollo de aplicaciones web, plataformas Moodle para e-learning
                e infraestructura en la nube.</strong> Ofrecemos  <strong>soluciones de Inteligencia Artificial con agentes sin código</strong>, 
                asegurando que cada proyecto maximice su rendimiento y escalabilidad. 
                Explora nuestros servicios y descubre cómo podemos hacer realidad tus proyectos con precisión, 
                optimizando tus sistemas y garantizando resultados excepcionales.
              </p>
            </div>
          </div>
          <Swiper {...serviceSlider} className="swiper services-slider">
            <div className="swiper-wrapper">
              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>01</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-1.webp"
                      }
                      alt="Diseño y desarrollo web - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  {/* H4 MEJORADO: Más específico */}
                  <h4>Diseño y Desarrollo Web</h4>
                  <p>
                    Creamos <strong>sitios web</strong> atractivos y funcionales que capturan la esencia de tu marca. 
                    Combinamos creatividad y usabilidad para ofrecer experiencias únicas que cautivan 
                    a tus clientes desde el primer clic.
                  </p>
                </div>
                {/* MICRODATA OCULTA */}
                <div style={{display: 'none'}}>
                  <span itemProp="provider" itemScope itemType="https://schema.org/Organization">
                    <span itemProp="name">Gekkonect</span>
                  </span>
                  <span itemProp="serviceType">Desarrollo de software personalizado</span>
                  <span itemProp="areaServed">México</span>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="400ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>02</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-2.webp"
                      }
                      alt="UI/UX Desarrollo de interfaces gráficas - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>UI/UX que Enamora</h4>
                  <p>
                    Diseñamos <strong>interfaces intuitivas</strong> y experiencias de usuario memorables, 
                    centradas en facilitar cada interacción. Tu producto no solo se verá increíble, 
                    sino que funcionará a la perfección, cautivando a tus usuarios en cada paso.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>03</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Software totalente a medida - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  {/* H4 MEJORADO: Incluye keyword principal */}
                  <h4>Software a Medida</h4>
                  <p>
                    Transformamos tus ideas en soluciones únicas y escalables, ajustadas a la perfección 
                    para satisfacer las demandas específicas de tu negocio. <strong>Tu visión, nuestro código.</strong>
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>04</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Aplicaciones web de alto rendimiento - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Aplicaciones Web de Alto Rendimiento</h4>
                  <p>
                    Creamos <strong>aplicaciones web</strong> rápidas, seguras y optimizadas que garantizan una experiencia 
                    de usuario fluida en cualquier dispositivo, maximizando tu <strong>presencia digital.</strong>
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>05</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Integraciones con sistemas empresariales - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Integraciones de Sistemas Empresariales</h4>
                  <p>
                    Conectamos tus <strong>sistemas</strong> para que trabajen en perfecta sincronía, <strong>optimizando procesos</strong>
                     y mejorando la eficiencia operativa de tu empresa a través de <strong>integraciones robustas.</strong>
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>06</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Apliciones móviles innovadoras - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Soluciones Móviles Innovadoras</h4>
                  <p>
                    Desarrollamos <strong>aplicaciones móviles</strong> intuitivas y potentes que mantienen a tus clientes conectados 
                    con tu marca, desde cualquier lugar y en cualquier momento.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>07</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Inteligencia Artificial y Machine Learning - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Inteligencia Artificial y Machine Learning</h4>
                  <p>
                    Potenciamos tu negocio con <strong>soluciones avanzadas de IA</strong> que transforman datos en decisiones 
                    estratégicas, brindando automatización y predicciones precisas. 
                    {/* Añadí mención a producto estrella */}
                    Incluyendo una plataforma de creación de <strong>agentes de inteligentes sin código.</strong>
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>08</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Consultoría tecnológica estratégica - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Consultoría Tecnológica Estratégica</h4>
                  <p>
                    Te guiamos en la adopción de <strong>tecnologías</strong> de vanguardia, <strong>optimizando tus recursos</strong> y 
                    asegurando un crecimiento sostenible y competitivo en tu sector.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>09</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Desarrollo de APIs y microservicios - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Desarrollo de APIs y Microservicios</h4>
                  <p>
                    Creamos <strong>APIs</strong> flexibles y <strong>microservicios</strong> eficientes que facilitan la conectividad y 
                    la escalabilidad, impulsando el crecimiento ágil de tu infraestructura tecnológica.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>10</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Optimizacion y modernización de software - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Optimización y Modernización de Software</h4>
                  <p>
                    Renovamos tu <strong>software legacy</strong> para mejorar su rendimiento, seguridad y funcionalidad, 
                    adaptándolo a las exigencias tecnológicas actuales sin interrumpir tu operación.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>11</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="SaaS a medida - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  <h4>Plataformas SaaS a Medida</h4>
                  <p>
                    Diseñamos y desarrollamos <strong>plataformas SaaS</strong> innovadoras que proporcionan soluciones 
                    de <strong>software escalables</strong> y fáciles de usar, listas para conquistar el mercado.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="swiper-slide wow animate fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div className={`${"single-service"} ${props.layoutClass}`}>
                  <span>12</span>
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/webp/icons/service-icon-3.webp"
                      }
                      alt="Arquitectura en la nube con AWS - Gekkonect"
                      loading="lazy"
                      width="64"
                      height="44"
                    />
                  </div>
                  {/* H4 MEJORADO: Más específico */}
                  <h4>Arquitectura en la Nube AWS</h4>
                  <p>
                    Ofrecemos diseño y desarrollo de <strong>arquitecturas robustas en AWS</strong>, adaptadas a tus necesidades. 
                    Desde la creación de estructuras <strong>a medida</strong> hasta la implementación de soluciones con productos AWS, 
                    optimizamos tu infraestructura en la nube para lograr <strong>eficiencia, escalabilidad y seguridad.</strong>
                  </p>
                </div>
              </SwiperSlide>
            </div>
          </Swiper>
          {/* <div className="swiper-button-next" />
          <div className="swiper-button-prev" /> */}
          {/* BOTONES DE NAVEGACIÓN MEJORADOS */}
          <div className="swiper-button-next" aria-label="Siguiente servicio" />
          <div className="swiper-button-prev" aria-label="Servicio anterior" />
        </div>
      </section>
    </>
  );
}

export default ServiceArea;